import * as React from 'react'
import styled from 'styled-components'

const Animation = styled.video`
  width: 24em;
  height: 24em;
  filter: contrast(87.5%);

  @media (min-width: 43em) {
    width: 30em;
    height: 30em;
  }

  @media (min-width: 62em) {
    width: 30em;
    height: 30em;
  }

  @media (min-width: 82em) {
    width: 42em;
    height: 42em;
  }
`

const SmallAnimation = styled.video`
  width: 20em;
  height: 20em;
  filter: contrast(88.5%);

  @media (min-width: 43em) {
    width: 24em;
    height: 24em;
  }
`

type Props = {
  small?: boolean
}

const GlassAnimation = ({ small }: Props): JSX.Element => {
  const AnimationComponent = small ? SmallAnimation : Animation
  return (
    <AnimationComponent loop autoPlay preload="auto" playsInline muted>
      <source src="https://us.glassapi.xyz/bgVideo.mp4" type="video/mp4" />
      <track kind="captions" />
      Your browser does not support HTML video.
    </AnimationComponent>
  )
}

export default GlassAnimation
